import React, { FunctionComponent, useState } from 'react';

import styles from './blog-articles-list.module.scss';
import {
  ArticleListItem,
  IArticleItem
} from '../article-list-item/article-list-item';
import { Container } from '../../container/container.component';
import { ButtonLoader } from '../../button-loader/button-loader';

export interface IBlogArticlesListProps {
  buttonText: string;
  articles: IArticleItem[];
}

const BlogArticlesListComponent: FunctionComponent<IBlogArticlesListProps> = props => {
  const { buttonText, articles } = props;
  const articlesToShow = 6;
  const [articlesListLength, setArticlesCount] = useState(articlesToShow);
  const articlesList = articles.slice(0, articlesListLength);

  const onButtonClick = (): void => {
    setArticlesCount(articlesListLength + articlesToShow);
  };

  return (
    <section className={styles.container}>
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.articles}>
            {articlesList.map((article: IArticleItem, i: number) => (
              <ArticleListItem data={article} key={i} />
            ))}
          </div>
          {articlesListLength < articles.length && (
            <div className={styles.loader}>
              <ButtonLoader buttonText={buttonText} onClick={onButtonClick} />
            </div>
          )}
        </div>
      </Container>
    </section>
  );
};

export const BlogArticlesList = React.memo(BlogArticlesListComponent);
